
import { Card, CardContent } from "@/components/ui/card";

export const ItemsEmptyState = () => {
  return (
    <Card>
      <CardContent className="pt-6">
        <p className="text-muted-foreground text-center">
          No products added yet. Click "Add Product" to get started.
        </p>
      </CardContent>
    </Card>
  );
};
